module.exports = __webpack_public_path__ + "media/images/riders/TRACEY_HANNAH-f6d81df79c4287aeaf7743a6aa9edc08.png";